import moment from "moment";
import { MessagesSubscription } from "./queries-chatto.generated";

export type SidebarState = "hidden" | "chat" | "participant";

export interface VideoToggleSettings {
    video: boolean;
    screen: boolean;
}

export type RoomSettings = {
    sidebarState: SidebarState;
    lastSeenMessageId: string;
    pinnedParticipants: Record<string, VideoToggleSettings>;
    tileFittedParticipants: Record<string, VideoToggleSettings>;
};

function getSettingByType(settings: VideoToggleSettings, screen: boolean) {
    return screen ? settings.screen : settings.video;
}

export function isPinned(settings: Record<string, VideoToggleSettings>, cname: string, screen: boolean) {
    return cname in settings ? getSettingByType(settings[cname], screen) : false;
}

export function isTileFitted(settings: Record<string, VideoToggleSettings>, cname: string, screen: boolean) {
    return cname in settings ? getSettingByType(settings[cname], screen) : false;
}

function setVideoToggle(
    settings: RoomSettings,
    attribute: "pinnedParticipants" | "tileFittedParticipants",
    cname: string,
    screen: boolean,
) {
    const newPins = { ...settings[attribute] };
    if (cname in newPins && newPins[cname]) {
        if (screen) newPins[cname].screen = true;
        else newPins[cname].video = true;
    } else newPins[cname] = screen ? { screen: true, video: false } : { screen: false, video: true };
    settings[attribute] = newPins;
}

function clearVideoToggle(
    settings: RoomSettings,
    attribute: "pinnedParticipants" | "tileFittedParticipants",
    cname: string,
    screen: boolean,
) {
    const newPins = { ...settings[attribute] };
    if (cname in newPins && newPins[cname]) {
        if (screen) newPins[cname].screen = false;
        else newPins[cname].video = false;

        if (newPins[cname].screen === false && newPins[cname].video === false) delete newPins[cname];
    }
    settings[attribute] = newPins;
}

export function setPin(settings: RoomSettings, cname: string, screen: boolean) {
    setVideoToggle(settings, "pinnedParticipants", cname, screen);
}

export function setTileFitted(settings: RoomSettings, cname: string, screen: boolean) {
    setVideoToggle(settings, "tileFittedParticipants", cname, screen);
}

export function clearPin(settings: RoomSettings, cname: string, screen: boolean) {
    clearVideoToggle(settings, "pinnedParticipants", cname, screen);
}

export function clearTileFitted(settings: RoomSettings, cname: string, screen: boolean) {
    clearVideoToggle(settings, "tileFittedParticipants", cname, screen);
}

export const defaultRoomSettings: RoomSettings = {
    sidebarState: "participant",
    lastSeenMessageId: null,
    pinnedParticipants: {},
    tileFittedParticipants: {},
};

type MessageBase = Pick<MessagesSubscription["message"], "contentType" | "content" | "messageId" | "sender" | "roomId">;

export type Message = MessageBase & {
    date: moment.Moment;
    isLocal: boolean;
};

export type FileMessageContent = {
    filename: string;
    preview_url?: string;
    file_url?: string;
    referred_msg_id?: string;
    metadata?: {
        mime_type?: string;
        size?: number;
        media_length?: number;
    };
};
